import React, { useEffect, useState } from "react";
import supabase from "../config/supabaseConfig";
import { toast } from "react-toastify";
import { EXERCICIOS_FIXOS, PCT, calcPct, maxDePct } from "./CargasAluno";
import "../styles/ControleCargaSala.css";

// Controle de carga dentro do card da Sala (pedido Rodrigo 02/10): substitui
// o painel de Volume por Grupamento. Mesma tabela da tela Editar Cargas
// (7 fixos + extras já salvos), editável ali mesmo: lança qualquer faixa
// (máx/alta/média/baixa) e as demais se calculam. Grava em `aluno_cargas`
// ao sair do campo (upsert aluno_id+exercicio_id) — sem botão Salvar, o
// professor está no meio da aula. Criar exercício extra continua só na
// tela de Cargas.
const ControleCargaSala = ({ alunoId }) => {
  const [linhas, setLinhas] = useState(() =>
    EXERCICIOS_FIXOS.map(({ nome, exercicioId }) => ({
      exercicioId,
      nome,
      max: "",
      isFixo: true,
    }))
  );
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        const { data, error } = await supabase
          .from("aluno_cargas")
          .select("exercicio_id, carga_maxima, is_fixo, exercicios(nome)")
          .eq("aluno_id", alunoId);
        if (error) throw error;
        if (!ativo) return;
        const porId = new Map((data || []).map((c) => [c.exercicio_id, c]));
        const fixos = EXERCICIOS_FIXOS.map(({ nome, exercicioId }) => {
          const c = porId.get(exercicioId);
          porId.delete(exercicioId);
          return { exercicioId, nome, max: c?.carga_maxima ?? "", isFixo: true };
        });
        const extras = Array.from(porId.values())
          .filter((c) => !c.is_fixo)
          .map((c) => ({
            exercicioId: c.exercicio_id,
            nome: c.exercicios?.nome || "Exercício extra",
            max: c.carga_maxima ?? "",
            isFixo: false,
          }));
        setLinhas([...fixos, ...extras]);
      } catch (err) {
        console.error("Erro ao carregar cargas do aluno:", err);
      } finally {
        if (ativo) setCarregando(false);
      }
    })();
    return () => {
      ativo = false;
    };
  }, [alunoId]);

  const setMax = (exercicioId, max) =>
    setLinhas((prev) =>
      prev.map((l) => (l.exercicioId === exercicioId ? { ...l, max } : l))
    );

  const salvar = async (linha) => {
    const max = Number(linha.max);
    // Sem carga (campo apagado) não grava — mesmo critério do Editar Cargas,
    // que só faz upsert de linha com carga > 0.
    if (!(max > 0)) return;
    const { error } = await supabase.from("aluno_cargas").upsert(
      {
        aluno_id: alunoId,
        exercicio_id: linha.exercicioId,
        carga_maxima: max,
        is_fixo: linha.isFixo,
        updated_at: new Date().toISOString(),
      },
      { onConflict: "aluno_id,exercicio_id" }
    );
    if (error) {
      console.error("Erro ao salvar carga:", error);
      toast.error(`Erro ao salvar carga de ${linha.nome}: ${error.message}`);
    }
  };

  if (carregando) return <p className="ccs-nota">Carregando cargas…</p>;

  const campo = (linha, valor, paraMax) => (
    <input
      type="number"
      min="0"
      inputMode="decimal"
      placeholder="—"
      value={valor ?? ""}
      onChange={(ev) => setMax(linha.exercicioId, paraMax(ev.target.value))}
      onBlur={() => salvar(linha)}
    />
  );

  return (
    <div className="controle-carga-sala">
      <p className="ccs-nota">
        Lança qualquer faixa, as demais se calculam. Salva ao sair do campo.
      </p>
      <div className="ccs-scroll">
        <table className="ccs-tabela">
          <thead>
            <tr>
              <th>Exercício</th>
              <th>Máx.</th>
              <th>
                Alta<small>90%</small>
              </th>
              <th>
                Média<small>75%</small>
              </th>
              <th>
                Baixa<small>65%</small>
              </th>
            </tr>
          </thead>
          <tbody>
            {linhas.map((l) => {
              const max = Number(l.max) || 0;
              return (
                <tr key={l.exercicioId}>
                  <td className="ccs-nome">{l.nome}</td>
                  <td>{campo(l, l.max, (v) => v)}</td>
                  <td>
                    {campo(l, calcPct(max, PCT.alta), (v) =>
                      maxDePct(v, PCT.alta)
                    )}
                  </td>
                  <td>
                    {campo(l, calcPct(max, PCT.media), (v) =>
                      maxDePct(v, PCT.media)
                    )}
                  </td>
                  <td>
                    {campo(l, calcPct(max, PCT.baixa), (v) =>
                      maxDePct(v, PCT.baixa)
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ControleCargaSala;
